/**
 *
 * Divider
 *
 */

import React from 'react';

import {
  DividerStyle
} from './styledComponents';

const Divider = ({marginBottom}) => {
  return <DividerStyle marginBottom={marginBottom} ></DividerStyle>
}

export default Divider;
